import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { LanguagesService } from 'src/app/domain/services';
import { AuthPopupService, AuthService } from '../../../auth/services';
import { SwitchLanguageService } from '../../../core/services';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: false
})
export class SidenavComponent {
    @Output() sidenavClose = new EventEmitter();

    languages = [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' }
    ];
    get selectedLanguageName(): string {
        return sessionStorage.getItem('selectedLanguage') === 'es'
            ? 'Español'
            : 'English';
    }

    user$ = this._auth.user$;

    constructor(
        public router: Router,
        private readonly _authPopup: AuthPopupService,
        private readonly _switchLanguage: SwitchLanguageService,
        private readonly _auth: AuthService,
        private readonly _language: LanguagesService
    ) {}

    get isSignedIn(): boolean {
        return this._auth.isSignedIn;
    }

    selectLanguage(val: string) {
        if (this.isSignedIn) {
            combineLatest([
                this._auth.user$.pipe(take(1)),
                this._language.languages$.pipe(take(1))
            ])
                .pipe(
                    switchMap(([user, languages]) => {
                        const language = languages.find((l) =>
                            l.languageCode.trim().includes(val)
                        );
                        if (
                            user &&
                            language &&
                            user.preferredLanguageId !== language.languageId
                        ) {
                            user.preferredLanguageId = language.languageId;
                            return this._auth.updateUser(user);
                        }
                        return EMPTY;
                    })
                )
                .subscribe(() => this._switchLanguage.switch(val));
        } else {
            this._switchLanguage.switch(val);
        }
    }

    onSidenavClose() {
        this.sidenavClose.emit();
    }

    signIn() {
        this.onSidenavClose();
        this._authPopup.showSignIn();
    }

    signOut() {
        this.router.navigate(['/sign-out']);
    }

    navigation(route: string) {
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }
}
